"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("isomorphic-fetch");
var _config = _interopRequireDefault(require("../../../consts/config"));
var _headers = require("../../../services/fetch/headers");
var _handlers = require("../../../services/fetch/handlers");
// empty object is returned on success

const handleMagicLinkResponse = json => {
  if ("error_code" in json) {
    if (json.error_code === "INVALID_ARGUMENT_EMAIL") {
      return {
        error: "INVALID_EMAIL"
      };
    }
    return {
      error: "UNKNOWN"
    };
  }
  return {
    success: true
  };
};
const createMagicLink = ({
  brandId,
  apiLanguage,
  email,
  origin
}) => {
  const payload = {
    brand: brandId,
    language: apiLanguage,
    endpoint: "magic-login-link",
    origin: origin !== null && origin !== void 0 ? origin : "kiwicom",
    email
  };
  return fetch(`${_config.default.apiAuthUrl}/v1/magic.create`, {
    method: "POST",
    headers: (0, _headers.getBasicHeaders)(),
    body: JSON.stringify(payload)
  }).then(_handlers.handleError).then(response => response.json()).then(handleMagicLinkResponse);
};
var _default = createMagicLink;
exports.default = _default;